import { useContext, useEffect, useState } from "react";
import { getUsers, createUsers, updateUsers, deleteUsers, sendTempPassword, resetOtp } from "../services/iam/users";
import { AppContext } from "../context";

type DataResponseType = "DATA" | "ID";
type ActionType = "CREATE" | "UPDATE" | "DELETE" | "DELETEALL" | "TEMP_PASSWORD" |"RESET_OTP";

const handleActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createUsers,
        fnMsg: t("Users.usersApiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: updateUsers,
        fnMsg: t("Users.usersApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: deleteUsers,
        fnMsg: t("Users.usersApiDeleteLabel"),
      };
    case "DELETEALL":
      return {
        actionFn: deleteUsers,
        fnMsg: t("Users.usersApiDeleteAllLabel"),
      };
    case "TEMP_PASSWORD":
      return {
        actionFn: sendTempPassword,
        fnMsg: t("Users.usersSendTemPassLabel"),
      };
    case "RESET_OTP":
      return {
        actionFn: resetOtp,
        fnMsg: t("Users.usersResetOtpLabel"),
      };
    default:
      return {
        actionFn: () => { },
        fnMsg: "",
      };
  }
};

export const useUsers = (type: DataResponseType) => {
  const {
    t,
    toast,
    appState: { ip, cookieKC, tenantId, selectedTenantId, selectedUser },
    setAppState,
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const userAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        if (action === "CREATE") {
          setAppState((prev) => ({
            ...prev,
            selectedUserRoleInfo: response?.data,
          }));
        }
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg.replace('{name}', `${data?.firstName ? data?.firstName : selectedUser?.firstName} ${data?.lastName ? data?.lastName : selectedUser?.lastName}`)}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getUsers(selectedTenantId ? selectedTenantId : tenantId))
          .then((response) => {
            const userResponse = response?.data;
            setData(userResponse);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [tenantId, toast, reload, type]);

  return {
    data,
    userAction,
    reloadFn,
  };
};
